import { action } from 'easy-peasy';

const uiModel = {
  drawerOpen: false,
  drawerTab: 'transitions',
  activeBoundary: null,
  transitionsByBoundary: {},

  setDrawerOpen: action((state, payload) => {
    state.drawerOpen = payload;
  }),
  setDrawerTab: action((state, payload) => {
    state.drawerTab = payload;
  }),
  openDrawer: action((state, { tab, boundary = null }) => {
    state.drawerTab = tab;
    state.drawerOpen = true;
    if (boundary != null) state.activeBoundary = boundary;
  }),
  setActiveBoundary: action((state, payload) => {
    state.activeBoundary = payload;
  }),
  setTransitionsByBoundary: action((state, payload) => {
    state.transitionsByBoundary = payload;
  })
};

export default uiModel;
